import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SpinnerComponent {

  @Input() public faIcon?: IconProp;
  @Input() public faIconSize?: SizeProp;
  @Input() public sizePx = 80;
  @Input() public loopIntervalMs = 1500;

  @HostBinding('style')
  private get hostSize(): object {
    const { sizePx } = this;
    return {
      width: `${sizePx}px`,
      height: `${sizePx}px`,
    };
  }

  protected get strokePx(): number {
    return Math.round(this.sizePx / 8);
  }

  protected get viewBox(): string {
    return `0 0 ${this.sizePx} ${this.sizePx}`;
  }

  protected get firstHalfPath(): string {
    const { sizePx, strokePx } = this;
    return [
      'M',
      sizePx - strokePx / 2,
      sizePx / 2,
      'A',
      sizePx / 2 - strokePx / 2,
      sizePx / 2 - strokePx / 2,
      0, 0, 1,
      strokePx / 2,
      sizePx / 2
    ].join(' ');
  }

  protected get secondHalfPath(): string {
    const { sizePx, strokePx } = this;
    return [
      'M',
      strokePx / 2,
      sizePx / 2,
      'A',
      sizePx / 2 - strokePx / 2,
      sizePx / 2 - strokePx / 2,
      0, 0, 1,
      sizePx - strokePx / 2,
      sizePx / 2,
    ].join(' ');
  }

  protected get roundCapPath(): string {
    const { sizePx, strokePx } = this;
    const extraPx = Math.round(strokePx / 10);
    return [
      'M',
      strokePx / 2,
      sizePx / 2,
      'A',
      sizePx / 2 - strokePx / 2,
      sizePx / 2 - strokePx / 2,
      0, 0, 1,
      strokePx / 2,
      sizePx / 2 - extraPx
    ].join(' ');
  }

}
